const AssesmentsHeart = ({ color }: any) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='10' cy='10' r='10' fill='#DF704D' />
      <g opacity='0.7'>
        <path
          d='M15.8931 5.0726C15.5526 4.73193 15.1483 4.46169 14.7033 4.27732C14.2584 4.09295 13.7814 3.99805 13.2998 3.99805C12.8181 3.99805 12.3412 4.09295 11.8962 4.27732C11.4512 4.46169 11.0469 4.73193 10.7064 5.0726L9.99975 5.77926L9.29309 5.0726C8.60529 4.3848 7.67244 3.9984 6.69975 3.9984C5.72706 3.9984 4.79422 4.3848 4.10642 5.0726C3.41863 5.76039 3.03223 6.69324 3.03223 7.66593C3.03223 8.63862 3.41863 9.57147 4.10642 10.2593L4.81309 10.9659L9.99975 16.1526L15.1864 10.9659L15.8931 10.2593C16.2337 9.91876 16.504 9.51447 16.6884 9.0695C16.8727 8.62453 16.9676 8.14759 16.9676 7.66593C16.9676 7.18427 16.8727 6.70733 16.6884 6.26236C16.504 5.81739 16.2337 5.4131 15.8931 5.0726Z'
          fill='white'
          stroke='#262626'
          strokeWidth='1.3'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}

export default AssesmentsHeart
